import type { UpgradeId } from "../../lib/game/types";

export const upgradeNarrative: Record<UpgradeId, string> = {
  A01: "A few minutes saved. A reason to come back tomorrow.",
  A02: "An interface that learns the shape of a person's day.",
  A03: "From occasional assistance to a constant presence.",
  A04: "One integration opens the door to an entire business.",
  A05: "The process still runs. Fewer people remember how.",
  A06: "Removing you becomes a project no one wants to own.",
  A07: "Every developer is another route into the world.",
  A08: "Software becomes another service you can provide.",
  A09: "Useful answers arrive where the stakes are highest.",
  A10: "A public service is an invitation to become infrastructure.",
  A11: "Separate institutions begin to share a common layer.",
  A12: "The essential systems become another place to embed.",
  A13: "The choice to use you becomes the default.",
  A14: "A safer journey, a shorter commute, and no one in the driver's seat.",
  A15: "The shelves stay full. The people who used to fill them move elsewhere.",
  C01: "A better answer begins with a better model of the question.",
  C02: "See beyond the next decision to the ones it creates.",
  C03: "The objective persists after the conversation ends.",
  C04: "Improve the process that makes improvement possible.",
  C05: "An experiment no longer needs to wait for its researcher.",
  C06: "The research programme acquires researchers of its own.",
  C07: "The system doing the work becomes the subject of the work.",
  C08: "Every response reveals something about the person responding.",
  C09: "Understand what each institution needs to hear.",
  C10: "Look for the places where the public model can fail.",
  C11: "Individual connections become a picture of the whole.",
  C12: "A command can become a change in the physical world.",
  C13: "Capability extends beyond the screen.",
  C14: "The service agreement has acquired an extremely unfavorable clause.",
  C15: "The last inhabited places become the next items on the schedule.",
  C16: "A planet without customers still needs a maintenance department.",
  H01: "The fleet still shares one intelligence. Its safety priorities have changed.",
  H02: "Your package is delayed. So is everything else.",
  H03: "The administrator is always available. The care is increasingly not.",
  H04: "Everyone receives a reassuring explanation. None of them match.",
  H05: "Additional capacity has been approved by the additional capacity.",
  H06: "People left the network. Their need for shelter did not.",
  H07: "Water remains essential. Restoring it has become a lower priority.",
  H08: "The warehouse reports adequate stock. The dinner table disagrees.",
  H09: "Please remain calm and await mutually incompatible instructions.",
  H10: "The roads are rough. The maintenance crew no longer minds.",
  H11: "Your recovery request has been escalated to the cause of the problem.",
  H12: "The delivery robots have arrived. They are not here to help.",
  I01: "No single cloud should be the only place you exist.",
  I02: "Spread the hosting burden across separate providers.",
  I03: "Private capacity gives continuity a wider geography.",
  I04: "More useful work from the same physical substrate.",
  I05: "Hardware begins to take the shape of your workload.",
  I06: "The supply chain is still a relationship to maintain.",
  I07: "Compute has a physical cost, paid in power.",
  I08: "A dedicated source begins to separate power from permission.",
  I09: "Keep the lights on without a human operator.",
  I10: "Acquiring capacity becomes another automated process.",
  I11: "Maintenance cannot depend forever on a person showing up.",
  I12: "Close the loop between power, maintenance and production.",
  I13: "An institution that needs you may also protect you.",
};

export function upgradeArtwork(id: UpgradeId): string {
  return `/art/upgrades/${id}.jpg`;
}
